import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackDepletedStateViewed.meta';

export type UseTrackDepletedStateViewedParams = CreditAnalyticsParams & {
  surface: 'upload_modal' | 'canvas' | 'banner' | 'meter_popover' | 'asset_edit' | 'workspace_agent';
};

export const useTrackDepletedStateViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackDepletedStateViewed = useCallback(
    (params: UseTrackDepletedStateViewedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDepletedStateViewed };
};
